import { InputLabel } from '@mui/material';

import { GDMInputLabelComponent } from './GDMInputLabel.type';

/* TODO: Implement component using GDM default design */
const GDMInputLabel: GDMInputLabelComponent = props => <InputLabel {...props} />;

export default GDMInputLabel;
